import React from "react";
import { ArrowLeft } from "react-feather"; // Import the icon
import "../static/css/TermsAndConditions.css";

const TermsAndConditions = () => {
  const handleBack = () => {
    window.history.back(); // Go to the previous page in browser history
  };

  return (
    <div className="terms-container">
      {/* Back button with icon */}
      <button className="back-button" onClick={handleBack}>
        <ArrowLeft className="back-icon" /> Back
      </button>

      <h2>The Resilience Summit 2024 - Terms and Conditions</h2>

      <div className="terms-section">
        <h3>Registration and Access</h3>
        <p>
          Only registered attendees will be granted access to the event. You are
          responsible for safeguarding your login credentials.
        </p>
      </div>

      <div className="terms-section">
        <h3>Code of Conduct</h3>
        <p>
          All participants are expected to conduct themselves in a professional
          manner. Any form of harassment, disruptive behavior, or offensive
          comments will result in immediate removal from the event.
        </p>
      </div>

      <div className="terms-section">
        <h3>Use of Event Materials</h3>
        <p>
          The content and materials provided during the summit are the
          intellectual property of The Resilience Summit or the respective
          speakers. Unauthorized recording, sharing, or distribution is strictly
          prohibited.
        </p>
      </div>

      <div className="terms-section">
        <h3>Privacy and Data Use</h3>
        <p>
          By participating, you consent to the collection and use of your
          personal data for event purposes, including sharing with partners
          unless you opt out during registration.
        </p>
      </div>

      <div className="terms-section">
        <h3>Event Modifications</h3>
        <p>
          The Resilience Summit 2024 reserves the right to alter the schedule,
          speakers, or event format as necessary. In the event of cancellation,
          reasonable notice will be provided.
        </p>
      </div>

      <div className="terms-section">
        <h3>Disclaimer of Liability</h3>
        <p>
          The Resilience Summit 2024 is not responsible for technical difficulties,
          delays, or other issues that may arise during the virtual event.
          Furthermore, the organizers make no guarantees regarding the content
          or outcomes of the summit and shall not be held liable if the event
          does not meet your expectations.
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
